import { DEFAULT_MAX_CHARACTER_EXCERPT, EXCERPT_SUFFIX } from '../constants';

export const getExcerpt = (
  content: string,
  max: number = DEFAULT_MAX_CHARACTER_EXCERPT,
  suffix: string = EXCERPT_SUFFIX
): string => {
  if (content.length < max) {
    return content;
  }

  const cutoff = max - suffix.length;
  const lastSpaceIndex = content.substring(0, cutoff).lastIndexOf(' ');
  const endIndex = lastSpaceIndex === -1 ? cutoff : lastSpaceIndex;

  return `${content.substring(0, endIndex)}${suffix}`;
};
